<template>

    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                           {
                               name: $tc('messages.adverts', 2),
                               href: meta.links.index
                           },
                           {
                               name: $t('messages.edit'),
                               href: null
                           },
                       ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>
                        {{ $t('messages.information') }}
                    </div>
                    <div class="mt-1">
                        <ZoomableImage :src="advert.image_path">
                            <img
                                :src="advert.image_path"
                                class="w-36"
                                :alt="advert.name"
                            />
                        </ZoomableImage>
                    </div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name"/>
                            <FormInput required id="name" v-model="form.name" name="name" type="text" maxlength="191" class="mt-1 w-full"/>
                            <FormError :value="form.errors.name" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.url')" for="url"/>
                            <FormInput  id="url" v-model="form.url" name="url" type="url" maxlength="191" class="mt-1 w-full"/>
                            <FormError :value="form.errors.url" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.description')" for="description"/>
                            <FormTextarea
                                rows="3"
                                id="description"
                                v-model="form.description"
                                name="description"
                                type="text"
                                class="mt-1 w-full"
                                style="min-height: 60px"
                            />
                            <FormError :value="form.errors.description" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.type')" for="type" />
                            <FormSelect
                                id="type"
                                v-model="form.type"
                                :options="options.types"
                                class="mt-1"
                                required
                            />
                            <FormError :value="form.errors.type" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.amount')" for="amount"/>
                            <FormInput required id="amount" v-model="form.amount" amount="amount" type="number" class="mt-1 w-full"/>
                            <FormError :value="form.errors.amount" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.published_at')" for="published_at"/>
                            <FormInput  id="published_at" v-model="form.published_at" name="published_at" type="datetime-local"  class="mt-1"/>
                            <FormError :value="form.errors.published_at" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.unpublished_at')" for="unpublished_at"/>
                            <FormInput  id="unpublished_at" v-model="form.unpublished_at" name="unpublished_at" type="datetime-local"  class="mt-1"/>
                            <FormError :value="form.errors.unpublished_at" class="mt-2"/>
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.image')" for="image" />
                            <input
                                id="image"
                                @input="form.image = $event.target.files[0]"
                                name="image"
                                type="file"
                                accept="image/*"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.image" class="mt-2" />
                        </div>
                    </div>

                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>

        </form>

    </PanelPage>
</template>

<script>
import PanelPage from '@/Shared/PanelPage.vue';
import CentralLayout from '@/Shared/CentralLayout.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import ZoomableImage from '@//components/ZoomableImage.vue';

export default {
    components: {
        ZoomableImage,
        FormTextarea,
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        AppButton,
    },
    layout: CentralLayout,
    name: 'Edit',
    props: ['meta', 'options', 'advert'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.advert.name,
                url: this.advert.url,
                type: this.advert.type,
                amount: this.advert.amount,
                description: this.advert.description,
                published_at: this.advert.published_at,
                unpublished_at: this.advert.unpublished_at,
                _method: 'patch',
                image: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.update);
        },
    },
};
</script>
